import Loadable from '@townsquare/loadable';

export const SearchSidebarNavigation = Loadable({
	loader: () =>
		import(/* webpackChunkName: "search-sidebar-navigation" */ './SearchSidebarNavigation'),
	loading: () => null,
});
